(function () {
  window.__ecwGiftConfig = window.__ecwGiftConfig || {};
  window.__ecwLastBundleCartAdd = 0;

  var MIN_GIFT_QTY = 3;

  function isGiftEligibleQty(qty) {
    return (parseInt(qty, 10) || 0) >= MIN_GIFT_QTY;
  }

  function getFormGiftField(form, name) {
    if (!form) return '';
    var el = form.querySelector('[name="' + name + '"]');
    if (el && el.value) return String(el.value).trim();
    if (form.id) {
      el = document.querySelector('[name="' + name + '"][form="' + form.id + '"]');
      if (el && el.value) return String(el.value).trim();
    }
    return '';
  }

  function collectFormProperties(formData) {
    var props = {};
    formData.forEach(function (value, key) {
      var match = key.match(/^properties\[(.+)\]$/);
      if (match) props[match[1]] = value;
    });
    return props;
  }

  function getGiftColorForForm(form) {
    var color = getFormGiftField(form, 'properties[_bundle_gift_color]').toLowerCase();
    if (color === 'white' || color === 'black') return color;
    return 'black';
  }

  function getGiftVariantIdForColor(color) {
    var cfg = window.__ecwGiftConfig;
    if (color === 'white') return cfg.whiteVariantId || null;
    return cfg.blackVariantId || null;
  }

  function getGiftHandleForColor(color) {
    var cfg = window.__ecwGiftConfig;
    if (color === 'white') return cfg.whiteHandle || 'bolsita-impermeable-de-regalo-blanco';
    return cfg.blackHandle || 'bolsita-impermeable-de-regalo-negro';
  }

  window.__ecwShouldAddBundleGift = function (form) {
    if (!form) return false;
    if (getFormGiftField(form, 'properties[_bundle_gift_eligible]') !== 'true') return false;
    var packQty = parseInt(getFormGiftField(form, 'properties[_bundle_gift_qty]') || '0', 10);
    return isGiftEligibleQty(packQty) && !!getGiftVariantIdForColor(getGiftColorForForm(form));
  };

  window.__ecwMarkCartAdd = function () {
    window.__ecwLastBundleCartAdd = Date.now();
  };

  window.__ecwFetchCartSections = async function (cartComponent) {
    if (!cartComponent || typeof cartComponent.getSectionsToRender !== 'function') return {};
    var ids = cartComponent.getSectionsToRender().map(function (section) {
      return section.id;
    });
    if (!ids.length) return {};
    var url = window.location.pathname + '?sections=' + ids.join(',');
    var response = await fetch(url, { credentials: 'same-origin' });
    return response.json();
  };

  window.__ecwRefreshCartDrawer = async function () {
    var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
    var response = await fetch(cartUrl + '?section_id=cart-drawer', { credentials: 'same-origin' });
    var htmlText = await response.text();
    var doc = new DOMParser().parseFromString(htmlText, 'text/html');

    ['cart-drawer-items', '.cart-drawer__footer'].forEach(function (selector) {
      var target = document.querySelector(selector);
      var source = doc.querySelector(selector);
      if (target && source) target.replaceWith(source);
    });

    var newDrawer = doc.querySelector('cart-drawer');
    var currentDrawer = document.querySelector('cart-drawer');
    if (newDrawer && currentDrawer) {
      currentDrawer.classList.toggle('is-empty', newDrawer.classList.contains('is-empty'));
    }

    if (typeof window.__ecwFetchCartSections === 'function') {
      var bubbleData = await fetch(window.location.pathname + '?sections=cart-icon-bubble', {
        credentials: 'same-origin'
      }).then(function (r) { return r.json(); }).catch(function () { return {}; });

      var bubbleEl = document.getElementById('cart-icon-bubble');
      if (bubbleEl && bubbleData['cart-icon-bubble']) {
        var parsed = new DOMParser().parseFromString(bubbleData['cart-icon-bubble'], 'text/html');
        var inner = parsed.querySelector('.shopify-section');
        if (inner) bubbleEl.innerHTML = inner.innerHTML;
      }
    }
  };

  window.__ecwAddBundleProductAndGift = async function (form) {
    if (!window.__ecwShouldAddBundleGift(form)) return null;

    var formData = new FormData(form);
    var packQty = parseInt(getFormGiftField(form, 'properties[_bundle_gift_qty]') || '0', 10);
    var variantId = formData.get('id');
    if (!variantId) return { error: { description: 'Variante no encontrada' } };

    var properties = collectFormProperties(formData);
    var color = getGiftColorForForm(form);
    var giftVariantId = getGiftVariantIdForColor(color);
    var giftHandle = getGiftHandleForColor(color);

    window.__ecwMarkCartAdd();

    var productRes = await fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      credentials: 'same-origin',
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: packQty, properties: properties }]
      })
    }).then(function (r) { return r.json(); });

    if (productRes.status) return { error: productRes };

    if (giftVariantId) {
      var cart = await fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
      var hasGift = cart.items.some(function (item) { return item.handle === giftHandle; });

      if (!hasGift) {
        var giftRes = await fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          credentials: 'same-origin',
          body: JSON.stringify({
            items: [{
              id: Number(giftVariantId),
              quantity: 1,
              properties: { 'Bolsita impermeable': 'Gratis', '_bundle_gift_auto': 'true' }
            }]
          })
        }).then(function (r) { return r.json(); });

        if (giftRes.status) {
          console.error('Bolsita de regalo no agregada:', giftRes.description || giftRes.message);
        }
      }
    }

    return { ok: true, variantId: variantId };
  };

  function isBundleGiftHandle(handle) {
    var cfg = window.__ecwGiftConfig || {};
    return handle === (cfg.whiteHandle || 'bolsita-impermeable-de-regalo-blanco') ||
      handle === (cfg.blackHandle || 'bolsita-impermeable-de-regalo-negro');
  }

  function isCompresaCartItem(item) {
    var handle = (item.handle || '').toLowerCase();
    var title = ((item.product_title || item.title || '') + '').toLowerCase();
    return handle.indexOf('compresa') !== -1 || handle.indexOf('protegeslip') !== -1 ||
      title.indexOf('compresa') !== -1 || title.indexOf('protegeslip') !== -1;
  }

  window.__ecwIsBundleGiftItem = function (item) {
    if (!item) return false;
    if (isBundleGiftHandle(item.handle)) return true;
    if (item.properties && item.properties._bundle_gift_auto != null &&
      String(item.properties._bundle_gift_auto).trim() !== '') return true;
    var title = ((item.product_title || item.title || '') + '').toLowerCase();
    return (parseInt(item.final_price, 10) || 0) === 0 &&
      title.indexOf('bolsita') !== -1 && title.indexOf('regalo') !== -1;
  };

  window.__ecwHasEligiblePackLine = function (cart) {
    if (!cart || !cart.items) return false;
    return cart.items.some(function (item) {
      if (window.__ecwIsBundleGiftItem(item)) return false;
      if (!isCompresaCartItem(item)) return false;
      var qty = parseInt(item.quantity, 10) || 0;
      return isGiftEligibleQty(qty);
    });
  };

  window.__ecwRemoveOrphanGifts = async function (cartOptional) {
    var cart = cartOptional;
    if (!cart) {
      cart = await fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
    }

    if (window.__ecwHasEligiblePackLine(cart)) return false;

    var updates = {};
    cart.items.forEach(function (item) {
      if (window.__ecwIsBundleGiftItem(item)) {
        updates[item.key] = 0;
      }
    });

    if (Object.keys(updates).length === 0) return false;

    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      credentials: 'same-origin',
      body: JSON.stringify({ updates: updates })
    });

    if (typeof window.__ecwRefreshCartDrawer === 'function') {
      await window.__ecwRefreshCartDrawer();
    }

    return true;
  };

  window.__ecwEnsureGiftForCart = async function () {
    var cfg = window.__ecwGiftConfig;
    if (!cfg.whiteVariantId && !cfg.blackVariantId) return false;

    var cart = await fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
    var eligibleItems = [];

    cart.items.forEach(function (item) {
      if (item.handle === cfg.whiteHandle || item.handle === cfg.blackHandle) return;
      var handle = (item.handle || '').toLowerCase();
      var title = ((item.product_title || item.title || '') + '').toLowerCase();
      var isCompresa = handle.indexOf('compresa') !== -1 || handle.indexOf('protegeslip') !== -1 || title.indexOf('compresa') !== -1;
      if (!isCompresa) return;
      var qty = parseInt(item.quantity, 10) || 0;
      if (!isGiftEligibleQty(qty)) return;

      var color = 'black';
      if (handle.indexOf('blanco') !== -1 || handle.indexOf('white') !== -1) color = 'white';

      eligibleItems.push({ qty: qty, color: color });
    });

    if (!eligibleItems.length) return false;

    eligibleItems.sort(function (a, b) { return b.qty - a.qty; });
    var top = eligibleItems[0];
    var desiredHandle = getGiftHandleForColor(top.color);
    var desiredVariantId = getGiftVariantIdForColor(top.color);
    if (!desiredHandle || !desiredVariantId) return false;

    var hasGift = cart.items.some(function (item) { return item.handle === desiredHandle; });
    if (hasGift) return false;

    var giftRes = await fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      credentials: 'same-origin',
      body: JSON.stringify({
        items: [{
          id: Number(desiredVariantId),
          quantity: 1,
          properties: { 'Bolsita impermeable': 'Gratis', '_bundle_gift_auto': 'true' }
        }]
      })
    }).then(function (r) { return r.json(); });

    return !giftRes.status;
  };
})();
